// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UvxV0","comment":"styles_comment__2QLpf"};